// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleExceptionReviewer = {
  id: "exception-reviewer",
  mrn: "//iam.api.mondoo.app/roles/exception-reviewer",
  title: "Exception Reviewer",
  allowedActions,
} as const;

export type RoleExceptionReviewer = typeof roleExceptionReviewer;
